import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/**
 * 직원의 선택 여부 — 병원별로 기억한다.
 *
 * departmentID 는 서버가 채워 보내면 객체, 화면에서 만든 값이면 문자열이라 둘 다 받는다.
 */
export type StoredEmployee = {
    _id: string
    departmentID?: string
    isSelected: boolean
    sortNum?: number
}

type EmployeeInput = {
    _id: string
    departmentID?: string | { _id: string }
    isSelected: boolean
    sortNum?: number
}

export type V2EmployeeState = {
    hospitals: Record<string, StoredEmployee[] | undefined>
}

const state: V2EmployeeState = {
    hospitals: {},
}

const departmentIDOf = (value: EmployeeInput['departmentID']): string | undefined =>
    typeof value === 'object' ? value?._id : value

const mutations = {
    /** 처음 보는 직원은 새로 넣는다 — 그래야 토글이 persist 된다 */
    MU_V2Employee_Update: (
        state: V2EmployeeState,
        param: { hospitalID: string; employees: EmployeeInput[] },
    ): void => {
        const hospitalID = param.hospitalID
        const employees = param.employees
        const origins = state.hospitals[hospitalID] ?? []
        for (let i = 0; i < employees.length; i++) {
            const employee = employees[i]
            const origin = origins.find((c) => c._id == employee._id)
            if (origin == undefined) {
                origins.push({
                    _id: employee._id,
                    departmentID: departmentIDOf(employee.departmentID),
                    isSelected: employee.isSelected,
                    sortNum: employee.sortNum,
                })
                continue
            }
            origins[origins.indexOf(origin)].isSelected = employee.isSelected
        }
        state.hospitals[hospitalID] = origins
    },
}

const V2Employee: Module<V2EmployeeState, StoreState> = { state, mutations }

export default V2Employee
